import {RouteConfig} from 'vue-router';
import DashboardLayout from '@/components/Dashboard/Layout/DashboardLayout.vue';
import NewslettersList from '@/pages/Newsletters/NewslettersList.vue';
import NewslettersCreate from '@/pages/Newsletters/CreateForm.vue';
import NewslettersPage from '@/pages/Newsletters/NewsletterPage.vue';
import NewslettersInfo from '@/components/Newsletters/Page/Page.vue';
import NewslettersReadyList from '@/components/Newsletters/List/ready.vue';
import NewslettersInProgressList from '@/components/Newsletters/List/inProgress.vue';
import NewslettersCompletedList from '@/components/Newsletters/List/completed.vue';
import NewslettersCanceledList from '@/components/Newsletters/List/canceled.vue';

import {
  USER_ROLE_MAILING
} from '@/constants'

// @ts-ignore
import messages from '@/lang/index';

const newslatter: RouteConfig = {
  path: '/newsletters',
  name: 'newsletters',
  meta: {
    pageName: messages.newsletters.page_name,
    access: USER_ROLE_MAILING
  },
  component: DashboardLayout,
  redirect: '/newsletters/list',
  children: [
    {
      path: 'list',
      name: 'newslettersList',
      meta: {
        pageName: messages.common.sidebar_links.newsletters.list,
        access: USER_ROLE_MAILING
      },
      component: NewslettersList,
      redirect: {name: 'newslettersReadyList'},
      children: [
        {
          path: 'ready',
          name: 'newslettersReadyList',
          meta: {
            pageName: messages.common.tabs.ready,
            access: USER_ROLE_MAILING
          },
          component: NewslettersReadyList,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersReadyListPage',
              meta: {
                pageName: messages.common.tabs.ready,
                access: USER_ROLE_MAILING
              },
              component: NewslettersReadyList,
            }
          ]
        },
        {
          path: 'inProgress',
          name: 'newslettersInProgressList',
          meta: {
            pageName: messages.common.tabs.in_progress,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInProgressList,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersInProgressListPage',
              meta: {
                pageName: messages.common.tabs.in_progress,
                access: USER_ROLE_MAILING
              },
              component: NewslettersInProgressList,
            }
          ]
        },
        {
          path: 'completed',
          name: 'newslettersComplitedList',
          meta: {
            pageName: messages.common.tabs.completed,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCompletedList,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersComplitedListPage',
              meta: {
                pageName: messages.common.tabs.completed,
                access: USER_ROLE_MAILING
              },
              component: NewslettersCompletedList,
            }
          ]
        },
        {
          path: 'canceled',
          name: 'newslettersCanceledList',
          meta: {
            pageName: messages.common.tabs.canceled,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCanceledList,
          children: [
            {
              path: 'page/:page',
              name: 'newslettersCanceledListPage',
              meta: {
                pageName: messages.common.tabs.canceled,
                access: USER_ROLE_MAILING
              },
              component: NewslettersCanceledList,
            }
          ]
        }
      ]
    },
    {
      path: 'create',
      name: 'newslettersCreate',
      meta: {
        pageName: messages.newsletters.create_to_student,
        access: USER_ROLE_MAILING
      },
      component: NewslettersCreate,
      children: [
        {
          path: 'page/:page',
          name: 'newslettersCreatePage',
          meta: {
            pageName: messages.newsletters.create_to_student,
            access: USER_ROLE_MAILING
          },
          component: NewslettersCreate
        },
      ]
    },
    {
      path: ':id',
      name: 'newsletterPage',
      meta: {
        pageName: messages.common.sidebar_links.newsletters.main_staff,
        access: USER_ROLE_MAILING
      },
      component: NewslettersPage,
      props: true,
      redirect: {name: 'newsletterInfo'},
      children: [
        {
          path: 'info',
          name: 'newsletterInfo',
          meta: {
            pageName: messages.newsletters.info_short,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInfo,
          props: true
        },
        {
          path: 'info/page/:page',
          name: 'newsletterInfoPage',
          meta: {
            pageName: messages.newsletters.info_short,
            access: USER_ROLE_MAILING
          },
          component: NewslettersInfo,
          props: true
        }
      ]
    }
  ]
};
export default newslatter;